"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTangentNormalAtParametricPoint = getTangentNormalAtParametricPoint;
var _getPointTangent = require("./getPointTangent");
var _vector = require("./vector");
/**
 * Return the tangent and normal of a specific point on an entity. The tangent points in the CCW direction, and the normal points away from the finished part.
 * @param contour The contour this entity came from. This is used to put the normal on the correct side (pointing away from the finished part)
 * @param entity The entity to get the tangent/normal on
 * @param parametric The point (0..1) at which to get the tangent/normal
 */
function getTangentNormalAtParametricPoint(contour, entity, parametric) {
  let [point, tangent] = (0, _getPointTangent.getPointTangentOfEntity)(entity, parametric);
  tangent = (0, _vector.mul)(tangent, 1 / (0, _vector.norm)(tangent));
  if (entity.reversed) {
    tangent = (0, _vector.mul)(tangent, -1);
  }
  if (contour.properties.area < 0) {
    // Contour is traversed in other direction
    tangent = (0, _vector.mul)(tangent, -1);
  }

  // Compute normal (pointing away from the finished part)
  let normal = {
    x: tangent.y,
    y: -tangent.x
  };
  if (contour.type === 'inner') {
    normal = (0, _vector.mul)(normal, -1);
  }

  // At this point, tangent points in the CCW direction. If the part should be cut CW, then reverse it again.

  return {
    point,
    tangent,
    normal
  };
}